import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'sweetalert2/dist/sweetalert2.css'
// Cores dos temas claro e escuro: depois do Bootstrap, para as correções do escuro valerem
import './theme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

